export default __webpack_public_path__ + "static/media/game_starter.511f033e.mp3";